import { Swiper } from 'swiper';
import {Navigation} from "swiper/modules";
Swiper.use([Navigation]);

export default () => {
    const nodeSelectors = {
        container: '[js-testimonials-slider="container"]',
        slider: '[js-testimonials-slider="slider"]',
        prev: '[js-testimonials-slider="prev"]',
        next: '[js-testimonials-slider="next"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.slider)) {
            return
        }

        initSlider()
    }

    function initSlider() {
        let slidersContainers = document.querySelectorAll(nodeSelectors.container)

        slidersContainers.forEach(function (container, index) {
            let sliderEl = container.querySelector(nodeSelectors.slider)

            let slider = new Swiper(sliderEl, {
                slidesPerView: 1,
                spaceBetween: 25,
                loop: true,
                speed: 500,
                navigation: {
                    nextEl: container.querySelector(nodeSelectors.next),
                    prevEl: container.querySelector(nodeSelectors.prev),
                }
            });
        })
    }

    return Object.freeze({
        init,
    })
}